/* Shine & Style — category arc.
 *
 * Five circles on a curve: the chosen category large in the
 * middle, two either side stepping smaller and higher, and the
 * name with its piece count underneath. Swipe left or right, tap a
 * neighbour, use the arrows, or use the arrow keys.
 *
 * Layered on top of the grid, never instead of it. The Liquid
 * renders every category as a plain link; this adds a class and
 * some chrome. If it never runs, the page is the grid.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-arc]');
  if (!root) return;

  var tiles = Array.prototype.slice.call(root.querySelectorAll('.ss-ctile'));
  /* The arc has five slots. With fewer than five categories the
     same circle would have to appear in two of them. */
  if (tiles.length < 5) return;

  var rtl = document.documentElement.dir === 'rtl';
  var index = 0;

  /* ---------------------------------------------------------
     Chrome
     --------------------------------------------------------- */
  var shell = document.createElement('div');
  shell.className = 'ss-arc';
  root.parentNode.insertBefore(shell, root);
  shell.appendChild(root);
  root.classList.add('is-arc');

  var caption = document.createElement('div');
  caption.className = 'ss-arc__caption';
  caption.innerHTML =
    '<a class="ss-arc__name" href="#"></a>' +
    '<p class="ss-arc__count"></p>' +
    '<p class="ss-arc__pos" aria-live="polite"><b data-cur>1</b> / <span data-total>1</span></p>';
  shell.appendChild(caption);

  var nav = document.createElement('div');
  nav.className = 'ss-arc__nav';
  nav.innerHTML =
    '<button class="ss-arc__btn" type="button" data-prev aria-label="Previous category">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>' +
    '</button>' +
    '<button class="ss-arc__btn" type="button" data-next aria-label="Next category">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>' +
    '</button>';
  shell.appendChild(nav);

  var nameEl  = caption.querySelector('.ss-arc__name');
  var countEl = caption.querySelector('.ss-arc__count');
  var curEl   = caption.querySelector('[data-cur]');
  caption.querySelector('[data-total]').textContent = tiles.length;

  /* ---------------------------------------------------------
     Which slot each category sits in
     Offset is signed distance from the middle, wrapped so the arc
     is a loop. In Arabic the slots mirror, so the categories run
     right to left like everything else on the page.
     --------------------------------------------------------- */
  function slotFor(i) {
    var n = tiles.length;
    var d = i - index;
    if (d > n / 2) d -= n;
    if (d < -n / 2) d += n;
    if (d < -2) return 'off-start';
    if (d > 2) return 'off-end';
    return String(rtl ? -d : d);
  }

  function render() {
    tiles.forEach(function (tile, i) {
      var slot = slotFor(i);
      tile.setAttribute('data-pos', slot);

      /* Circles off the ends of the arc are invisible, so they are
         taken out of the tab order too - a keyboard should not
         walk through links nobody can see. The arrows and the
         caption link are the way through. */
      var off = slot === 'off-start' || slot === 'off-end';
      tile.setAttribute('aria-hidden', off ? 'true' : 'false');
      tile.tabIndex = off ? -1 : 0;
    });

    var active = tiles[index];
    var name = active.querySelector('.ss-ctile__name');
    var count = active.querySelector('.ss-ctile__count');

    nameEl.textContent = name ? name.textContent.trim() : '';
    nameEl.setAttribute('href', active.getAttribute('href'));
    countEl.textContent = count ? count.textContent.trim() : '';

    /* The caption's rule and the position marker take the active
       category's own step of red, the same one its ring uses. */
    var cat = active.getAttribute('data-cat');
    if (cat) shell.setAttribute('data-cat', cat);

    curEl.textContent = index + 1;
  }

  function go(delta) {
    index = (index + delta + tiles.length) % tiles.length;
    render();
  }

  /* No direction check here. Next means the next category in both
     languages; what changes is which side of the arc it arrives
     from, and the stylesheet already mirrors the chevrons. Flipping
     the icon and the behaviour both is a double negative - in
     Arabic the button drawn as "forward" was stepping backwards. */
  nav.querySelector('[data-prev]').addEventListener('click', function () { go(-1); });
  nav.querySelector('[data-next]').addEventListener('click', function () { go(1); });

  /* Tapping a circle on the arc turns it to the middle rather than
     navigating - the middle one is the only one committing to a
     page. */
  tiles.forEach(function (tile, i) {
    tile.addEventListener('click', function (e) {
      if (tile.getAttribute('data-pos') !== '0') {
        e.preventDefault();
        index = i;
        render();
      }
    });
  });

  shell.setAttribute('tabindex', '-1');
  shell.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { go(rtl ? -1 : 1); e.preventDefault(); }
    if (e.key === 'ArrowLeft')  { go(rtl ? 1 : -1); e.preventDefault(); }
  });

  /* ---------------------------------------------------------
     Swipe
     Horizontal only. The threshold is generous and a mostly
     vertical drag is ignored outright, so scrolling the page past
     the arc never turns it by accident.
     --------------------------------------------------------- */
  var startX = 0, startY = 0, tracking = false;

  shell.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    tracking = true;
  }, { passive: true });

  shell.addEventListener('touchend', function (e) {
    if (!tracking) return;
    tracking = false;
    var t = e.changedTouches[0];
    var dx = t.clientX - startX;
    var dy = t.clientY - startY;
    if (Math.abs(dx) < 44) return;              // too small to mean it
    if (Math.abs(dy) > Math.abs(dx) * 0.8) return;  // that was a scroll
    /* Drag left, the arc turns forward - the circles follow the
       finger, which is the way every phone carousel behaves. */
    go((dx < 0) === !rtl ? 1 : -1);
  }, { passive: true });

  render();
})();
